import React from 'react';
import {
  ProFormText,
  ProFormSwitch,
  ProFormTextArea,
  ProFormCheckbox,
  ProFormDigit,
} from '@ant-design/pro-form';
import ProForm from '../../../layout/ProForm';
import PropTypes from 'prop-types';
import { GET_TEAM_MEMBER_TYPE_SCOPE_TYPE } from '../../../../gql/teamMemberTypes';
import { useQuery } from '@apollo/client';

const TeamMemberForm = ({ onFinish, initialValues, isEdit }) => {
  const { data, loading } = useQuery(GET_TEAM_MEMBER_TYPE_SCOPE_TYPE);
  return (
    <ProForm
      loading={loading}
      onFinish={onFinish}
      initialValues={{ ...initialValues, active: !initialValues.disabled }}
    >
      <ProFormText
        width="xl"
        name="name"
        label="Name"
        rules={[
          { required: true, message: 'Please enter team member type name!' },
          { whitespace: true },
        ]}
      />
      <ProFormSwitch
        name="isPL"
        label="Consider as Project Leader?"
        tooltip="The approval route will depend on the PL"
      />

      <ProFormDigit
        width="xl"
        label="Display Sequence"
        name="seq"
        min={1}
        max={9999}
        fieldProps={{ precision: 0 }}
        rules={[{ required: true }]}
      />
      <ProFormTextArea width="xl" name="description" label="Description" />
      {isEdit && <ProFormSwitch name="active" label="Active" />}
      <ProFormCheckbox.Group
        name="scopeTypes"
        layout="vertical"
        label="Premission"
        options={data?.teamMemberTypeScopeType?.enumValues.map(
          ({ name, description }) => ({
            label: `${description}`,
            value: name,
          })
        )}
      />
    </ProForm>
  );
};

TeamMemberForm.defaultProps = {
  initialValues: {},
  isEdit: false,
};

TeamMemberForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default TeamMemberForm;
